import { useEffect, useState } from "react"

const StreckenverlaufAnzeige = ({ verlauf }) => {
    const [collection, setCollection] = useState([]);
    const [details, setDetails] = useState(false);

    useEffect(() => {
        setDetails(false);
        setCollection([]);
        // verlauf.sort((a, b) => a.pos > b.pos).forEach(element => {
            // setCollection(previous => [...previous, `-${element.bhf}-`])
        const sorted = (verlauf.sort((a, b) => a.pos > b.pos));
        setCollection(sorted.map(elem => elem.bhf).join(` | `));
        
    }, [verlauf])

    return (
        <ul type="none" className="liste-verlauf"  style={{paddingLeft: '1em'}}>
            {/* <li>von: <label style={{fontWeight: "bold"}}>{collection[0]}</label></li>
            <li>nach: <label style={{fontWeight: "bold"}}>{collection[collection.length - 1]}</label></li> */}
            <li><button onClick={() => setDetails(!details)}>&#8811; Details</button></li>
            {details && <li className="details">{collection}</li>}
        </ul>
    )
}

export default StreckenverlaufAnzeige